export default __webpack_public_path__ + "static/media/coffee-icon.ee80fd16.svg";